import { AuthData } from "../pages/Auth/reducer";

const AUTH_DATA_KEY = "authData";

export const saveAuthData = (authData: AuthData) => {
  localStorage.setItem(AUTH_DATA_KEY, JSON.stringify(authData));
};

export const getAuthData = (): AuthData | null => {
  const authDataString = localStorage.getItem(AUTH_DATA_KEY);
  if (!authDataString) return null;

  return JSON.parse(authDataString) as AuthData;
};

export const clearAuthData = () => {
  localStorage.removeItem(AUTH_DATA_KEY);
};
